export default {
  shared: {
    hooks: {
      useSearchParams: {
        name: 'По имени',
        passport: 'По паспорту',
        phone: 'По телефону',
        pinfl: 'По ПИНФЛ',
        clientId: 'По ID клиента',
        applicationId: 'По ID заявки',
      },
      useModuleOptions: {
        module_acquiring: 'Эквайринг & BML',
        module_alifshop: 'Alif Shop',
        module_azo: 'Alif Nasiya',
        module_admin: 'Админ панель',
      },
    },
  },
};
